import { trpc } from "~/lib/trpc"

interface IntakeProgressHeaderProps {
  coachId: string
  coachName: string
}

export default function IntakeProgressHeader({ coachId, coachName }: IntakeProgressHeaderProps) {
  const { data: progress, isLoading } = trpc.coaches.getIntakeProgress.useQuery({ coachId })

  if (isLoading || !progress) {
    return (
      <div className="sticky top-0 bg-background/95 backdrop-blur border-b p-3 z-10 animate-pulse">
        <div className="h-4 bg-muted rounded w-1/3 mb-2"></div>
        <div className="h-2 bg-muted rounded"></div>
      </div>
    )
  }

  // Only show for in-progress intake
  if (progress.intakeStatus !== "in-progress") {
    return null
  }

  return (
    <div className="sticky top-0 bg-background/95 backdrop-blur border-b border-border p-3 z-10">
      <div className="flex items-center justify-between mb-2">
        <span className="text-sm font-medium text-foreground">Setting up {coachName}</span>
        <span className="text-xs text-muted-foreground">
          {progress.completed}/{progress.total} topics
        </span>
      </div>

      {/* Progress bar */}
      <div className="h-2 bg-muted rounded-full overflow-hidden">
        <div
          className="h-full bg-primary transition-all duration-500 ease-out"
          style={{ width: `${progress.percentage}%` }}
        />
      </div>

      {/* Category dots (subtle indicator) */}
      <div className="flex gap-1.5 mt-2">
        {progress.categories.map((cat) => (
          <div
            key={cat.key}
            className={`flex-1 h-1 rounded-full transition-colors duration-300 ${
              cat.completed ? "bg-primary" : "bg-muted"
            }`}
            title={cat.label}
          />
        ))}
      </div>

      {/* Optional: Percentage text */}
      {progress.percentage > 0 && (
        <p className="text-xs text-muted-foreground mt-2 text-center">{progress.percentage}% complete</p>
      )}
    </div>
  )
}
